import { create } from 'zustand';

const useSpotlight3Store = create((set) => ({
  featuredImageDescription: 'Balance between all things, opposing forces coming together in harmony. We are connected.',
  featuredImage: 'https://live.staticflickr.com/65535/52681123118_2d9042b728_h.jpg',
  setFeaturedImage: (image) => set({ featuredImage: image }),
  setFeaturedImageDescription: (description) => set({ featuredImageDescription: description }),
}));

export default useSpotlight3Store;
